import React from "react";
import { TextField } from "@mui/material";

function DateField({ value, onChange }) {
  return (
    <TextField
      sx={{ backgroundColor: "#f9f9f9", borderRadius: "4px", fontSize: "12px" }}
      variant="outlined"
      size="small"
      type="date"
      name="date"
      fullWidth
      onChange={onChange}
      value={value}
    />
  );
}

export default DateField;
